import { TextField } from '@mui/material';
import React from 'react';
import { useTranslation } from '../../../../hooks/useTranslation';
import { ExchangeApiFormProps } from '../ExchangeApi';


const DefaultExchangeForm: React.FC<ExchangeApiFormProps> = ({ formData, setFormData }) => {
    const { t } = useTranslation();
    
    return (
        <>
            <TextField
                sx={{ mb: 2 }}
                label={t('integrations.exchange.api.apiKey')}
                value={formData.key_post}
                onChange={(e) => setFormData({ ...formData, key_post: e.target.value })}
            />
            <TextField
                sx={{ mb: 2 }}
                label={t('integrations.exchange.api.apiSecret')}
                type="password"
                value={formData.secret_post}
                onChange={(e) => setFormData({ ...formData, secret_post: e.target.value })}
            />
        </>
    );
};

// Export validation function separately
export const isDefaultFormValid = (formData: { key_post: string; secret_post: string }) => {
    return Boolean(formData.key_post && formData.secret_post);
};

export default DefaultExchangeForm;
